import './NoteGrid.scss'
import DataGrid, { Column, Paging, Scrolling } from 'devextreme-react/data-grid';
import { encode } from 'html-entities';
import { NoteGridProps } from '../types/NoteGridProps';
import { formatShortDateShortTime } from '../../../../utils/date-utils';

export default function NoteGrid(props: NoteGridProps) {

    return (
        <div className='dx-card wide-card'>
            <div className='grid-header'>Notes</div>
            <DataGrid
                className={'notes-grid grid-with-header'}
                dataSource={props.notes}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                keyExpr={'noteID'}
            >
                <Paging enabled={false}></Paging>

                <Column
                    dataField={'createdOn'}
                    caption={'Created On'}
                    dataType="datetime"
                >
                </Column>
                <Column
                    dataField={'createdBy'}
                    caption={'Creator Name'}
                    dataType="string"
                />
                <Column
                    dataField={'noteText'}
                    caption={'Note Text'}
                    dataType="string"
                    cssClass={'multi-line'}
                    encodeHtml={false}
                    calculateDisplayValue={(rowData) => {
                        return encode(rowData.noteText).replaceAll('\r\n', '<br/>');
                    }}
                />
                <Column
                    dataField={'toEmailAddress'}
                    caption={'Emailed To'}
                    dataType="string"
                    cssClass={'multi-line'}
                    width={200}
                />
                {
                    props.showMarkAsReadCompanyTypeID &&
                    <Column
                        caption='Read Status'
                        width={130}
                        alignment="center"
                        cssClass='multi-line'
                        cellRender={(row: any) => {
                            if (row.data.createdByCompanyTypeID === props.showMarkAsReadCompanyTypeID) {
                                return <>
                                    {
                                        row.data.readOn ?
                                            <span className='read-by'>
                                                <i className='dx-icon dx-icon-Inscyth-Notifications'></i>
                                                Read by you on {formatShortDateShortTime(row.data.readOn)}
                                            </span>
                                            :
                                            <a onClick={(e) => {
                                                e.preventDefault();
                                                if (props.onMarkNoteAsRead) {
                                                    props.onMarkNoteAsRead(row.data.noteID);
                                                }
                                            }}>
                                                Mark as read
                                            </a>
                                    }
                                </>;
                            }
                            else return <></>;
                        }}
                    />
                }
            </DataGrid>
        </div>
    )
}
